const VERSION = {
  TWO: '2.1',
  THREE: '3.0',
  FOUR: '4.0',
};

const Card = function (version = VERSION.THREE) {
  this.version = version;

  for (var key in vCard.Entry) {
    var property = vCard.Entry[key];

    if (!property.version || property.version.indexOf(version) < 0) continue;

    var fn = 'add' + key[0].toUpperCase() + key.slice(1).toLowerCase();

    Card.prototype[fn] = (function (key, format) {
      return function () {
        var args = Array.prototype.slice.call(arguments);
        var lastArg = args.length > 0 ? args[args.length - 1] : undefined;

        var model = vCard.Type.hasOwnProperty(lastArg)
          ? args.slice(0, args.length - 1)
          : args;
        var value =
          (format &&
            format.replace(/\{([0-9]*)\}/g, function (match, parameter) {
              return model[parseInt(parameter)] || '';
            })) ||
          model[0];

        this.add(key, value, vCard.Type.hasOwnProperty(lastArg) && lastArg);
      };
    })(property.key, property.format);
  }

  this.add = function (entry, value, type) {
    var key = typeof entry === 'object' && entry.key ? entry.key : entry;

    !this[key] && (this[key] = []);
    var e = { value: value };
    type && (e.type = type);

    this[key].push(e);
  };
};
const vCard = {
  Version: VERSION,
  Entry: {
    ADDRESS: {
      'version': [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      'key': 'ADR',
      'format': ';;{0};{2};{4};{1};{3}',
      '@comment': 'usage: addAdr(street, code, city, country, state)',
    },
    AGENT: { version: [VERSION.TWO, VERSION.THREE], key: 'AGENT' },
    ANNIVERSARY: { version: [VERSION.FOUR], key: 'ANNIVERSARY' },
    BIRTHDAY: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'BDAY',
    },
    CALENDARADDURI: { version: [VERSION.FOUR], key: 'CALADRURI' },
    CALENDARURI: { version: [VERSION.FOUR], key: 'CALURI' },
    CATEGORIES: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'CATEGORIES',
    },
    CLASS: { version: [VERSION.THREE], key: 'CLASS' },
    CLIENTPIDMAP: { version: [VERSION.FOUR], key: 'CLIENTPIDMAP' },
    EMAIL: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'EMAIL',
    },
    FBURL: { version: [VERSION.FOUR], key: 'FBURL' },
    FORMATTEDNAME: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'FN',
    },
    GENDER: { version: [VERSION.FOUR], key: 'GENDER' },
    GEO: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'GEO' }, // FIXME two differents formats
    IMPP: { version: [VERSION.THREE, VERSION.FOUR], key: 'IMPP' },
    // TODO: KEY
    KIND: { version: [VERSION.FOUR], key: 'KIND' },
    LABEL: { version: [VERSION.TWO, VERSION.THREE], key: 'LABEL' },
    // TODO: LOGO
    MAILER: { version: [VERSION.TWO, VERSION.THREE], key: 'MAILER' },
    MEMBER: { version: [VERSION.FOUR], key: 'MEMBER' },
    NAME: {
      'version': [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      'key': 'N',
      'format': '{1};{0};;{2}',
      '@comment': 'usage: addName(firstname, lastname, title)',
    },
    NICKNAME: { version: [VERSION.THREE, VERSION.FOUR], key: 'NICKNAME' },
    NOTE: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'NOTE' },
    ORGANIZATION: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'ORG',
    },
    // TODO: PHOTO
    PHOTO: {
      version: [VERSION.FOUR],
      key: 'PHOTO',
      format: ';{0}',
    },
    PRODID: { version: [VERSION.THREE, VERSION.FOUR], key: 'PRODID' },
    PROFILE: { version: [VERSION.TWO, VERSION.THREE], key: 'PROFILE' },
    RELATED: { version: [VERSION.FOUR], key: 'RELATED' },
    REVISION: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'REV',
    },
    ROLE: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'ROLE' },
    SORTSTRING: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'SORT-STRING',
    },
    // TODO: SOUND
    SOURCE: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'SOURCE',
    },
    PHONE: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'TEL' },
    TITLE: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'TITLE',
    },
    TIMEZONE: {
      version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR],
      key: 'TZ',
    }, // FIXME: two differents formats
    UID: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'UID' },
    URL: { version: [VERSION.TWO, VERSION.THREE, VERSION.FOUR], key: 'URL' },
    XML: { version: [VERSION.FOUR], key: 'XML' },
  },
  Type: {
    HOME: 'HOME',
    WORK: 'WORK',
    CELL: 'CELL',
    MAIN: 'MAIN',
    OTHER: 'OTHER',
  },
  create: function (version) {
    for (var key in this.Version) {
      if (this.Version[key] === version) return new Card(version);
    }
    throw new Error('Unknown vCard version');
  },
  dump: function (card) {
    var str = 'BEGIN:VCARD\n';

    for (var key in card) {
      var entry = card[key];

      if (typeof entry === 'function') continue;

      if (Object.prototype.toString.call(entry) === '[object Array]') {
        for (var i = 0, l = entry.length; i < l; i++) {
          var e = entry[i];
          if (key === vCard.Entry.PHOTO.key) {
            str += key + e.value + '\n';
          } else {
            str +=
              key.toUpperCase() +
              (e.type ? ';TYPE=' + e.type.toUpperCase() + ':' : ':') +
              e.value +
              '\n';
          }
        }
      } else if (typeof entry === 'object') {
        str +=
          key.toUpperCase() +
          (entry.type ? ';TYPE=' + entry.type.toUpperCase() + ':' : ':') +
          entry.value +
          '\n';
      } else {
        str += key.toUpperCase() + ':' + entry + '\n';
      }
    }

    str += 'END:VCARD';

    return str;
  },
  export: function (card, name, force) {
    var a = document.createElement('a');
    a.download = name + '.vcf';
    a.textContent = name;

    if (Blob) {
      var blob = new Blob([this.dump(card)], { type: 'text/vcard' });
      a.href = URL.createObjectURL(blob);
    } else {
      a.href = 'data:text/vcard;base64,' + this.btoa(this.dump(card));
    }

    force && a.click();

    return a;
  },
  btoa: function (str) {
    str = unescape(encodeURIComponent(str));

    if (!btoa) {
      var b64c =
        'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';

      var i,
        res = '',
        length = str.length;
      for (i = 0; i < length - 2; i += 3) {
        res += b64c[str.charCodeAt(i) >>> 2];
        res +=
          b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
        res +=
          b64c[
            ((str.charCodeAt(i + 1) & 15) << 2) | (str.charCodeAt(i + 2) >>> 6)
          ];
        res += b64c[str.charCodeAt(i + 2) & 63];
      }

      if (length % 3 === 2) {
        res += b64c[str.charCodeAt(i) >>> 2];
        res +=
          b64c[((str.charCodeAt(i) & 3) << 4) | (str.charCodeAt(i + 1) >>> 4)];
        res += b64c[(str.charCodeAt(i + 1) & 15) << 2];
        res += '=';
      } else if (length % 3 === 1) {
        res += b64c[str.charCodeAt(i) >>> 2];
        res += b64c[(str.charCodeAt(i) & 3) << 4];
        res += '==';
      }

      return res;
    } else {
      return btoa(str);
    }
  },
};

export default vCard;
